<template>
    <div class="card-body p-10">
        <div class="row">
          <div class="col-12 my-2">
            <SwitchInput
                :id="`${id}-task-beReview`"
                :label="$t('tasks.label.beReview')"
                v-model="formData.need_review"
                img="/assets/media/icons/need_review.png"  
                imgClass="ms-2 h-20px"
            />
          </div>
            <Input
                :name="`${id}-name`"
                container-class="col-12 mb-5"
                type="text"
                :label="$t('tasks.label.title')"
                :isRequired="true" size="lg"
                v-model="formData.title"
            />
            <InputDate2
                :parent-id="'#'+id"
                containerClass="col-12 col-md-4 mb-5"
                labelClass="form-label fs-6 text-black"
                :name="'recurrent-expense-start-date'+id"
                :label="$t('recurrentExpense.label.startDate')"
                :isRequired="true"
                size="lg"
                :minDate="min"
                :maxDate="max"
                :placeholder="$t('recurrentExpense.placeholder.startDate')"
                v-model="formData.start_date"
                @update:modelValue="handleStartDateChange"
                dateFormat="d-m-Y H:i"
                enableTime
            />
           
            <InputDate2
                :parent-id="'#'+id"
                containerClass="col-12 col-md-4 mb-5"
                :name="'recurrent-expense-end-date'+id"
                :label="$t('recurrentExpense.label.endDate')"
                labelClass="form-label fs-6 text-black"
                :isRequired="false"
                size="lg"
                :minDate="formData.start_date"
                :maxDate="max"
                :placeholder="$t('recurrentExpense.placeholder.endDate')"
                dateFormat="d-m-Y H:i"
                v-model="formData.end_date"
                @update:modelValue="resetDelay"
                enableTime
            />
            <Input
                :name="`${id}-delay`"
                container-class="col-md-4 mb-5"
                type="number"
                :label="$t('tasks.label.delay')"
                :isRequired="false"
                size="lg"
                v-model="formData.delay_value"
                :IsInputGroup="true"
                @change.prevent="updateEndDate"
            >
              <template #default>
                <span class="input-group-text w-50 border-0 py-0">
                  <Select2
                      :parent-id="'#'+id"
                      container-class="w-100 p-0"
                      select-class="form-select form-select-transparent w-100 fs-7 lh-1 fw-bold py-0 select2-hidden-accessible"
                      :isRequired="false"
                      :multiple="false"
                      :show-search="true"
                      :name="`${id}-task-delay`"
                      label-class="form-label"
                      v-model="formData.delay_unit"
                      @update:modelValue="updateEndDate"
                  >
                        <option v-for="delay in delayFrequencyEnum" :key="delay.value" :value="delay.value"> {{ delay[locale] }} </option>
                    </Select2>
                </span>
              </template>
            </Input>
            <Select2
                :parent-id="'#'+id"
                :is-required="true"
                container-class="col-12 mb-5"
                :multiple="false"
                :show-search="true"
                :name="`${id}-task-step`"
                :label="$t('tasks.label.step')"
                label-class="form-label"
                v-model="formData.project_category_step_id"
            >
                <option v-for="step in milestones" :value="step?.id" :key="step?.id">
                    {{ step.title }}
                </option>
            </Select2>
            <Select2
                :parent-id="'#'+id"
                :is-required="true"
                container-class="col-12 mb-5"
                :multiple="false"
                :show-search="true"
                :name="`${id}-task-status`"
                :label="$t('tasks.label.status')"
                label-class="form-label"
                v-model="formData.task_status_id"
            >
                <option v-for="statut in status" :value="statut?.id" :key="statut?.id">
                    {{ statut.title }}
                </option>
            </Select2>
            <Select2
                :parent-id="'#'+id"
                :is-required="true"
                container-class="col-12 mb-5"
                :multiple="false"
                :show-search="true"
                :name="`${id}-task-prority`"
                :label="$t('tasks.label.priority')"
                label-class="form-label"
                v-model="formData.task_priority_id"
                :IsInputGroup="true"
                icon="bi bi-plus"
                :clickAddon="openCreatePriority"
            >
                <option v-for="priority in priorities" :value="priority?.id" :key="priority?.id">
                    {{ priority.title }}
                </option>
            </Select2>
            <Select2
                :parent-id="'#'+id"
                :is-required="true"
                container-class="col-12 mb-5"
                :multiple="true"
                :show-search="true"
                :name="`${id}-task-users`"
                :label="$t('tasks.label.users')"
                label-class="form-label"
                v-model="formData.users"
            >
                <option v-for="user in users" :value="user?.id" :key="user?.id">
                    {{ user.fullname ?? user.firstname + ' '+ user?.lastname}}
                </option>
            </Select2>
        </div>
        <Card class="card p-5 mb-5">
          <SwitchInput id="withReminder" :label="$t('reminder.create')" v-model="withReminder" :between="true"/>
        </Card>
        <div class="row" v-if="withReminder">
          <div class="col-6 d-flex align-items-center">
            <label :for="`input-${id}-task-alert-delay-value`">
              {{ $t('reminder.advertisement') }}
            </label>
          </div>
          <Input
              :name="`${id}-task-alert-delay-value`"
              container-class="col-6 mb-5"
              type="number"
              :isRequired="true"
              size="lg"
              v-model="formData.delay_value_alert"
              :IsInputGroup="true"
          >
                <span class="input-group-text w-50 border-0 py-0">
                  <Select2
                      container-class="w-100 p-0"
                      select-class="form-select form-select-transparent w-100 fs-7 lh-1 fw-bold py-0 select2-hidden-accessible"
                      :isRequired="false"
                      :multiple="false"
                      :show-search="true"
                      :name="`${id}-task-alert-delay-unit`"
                      v-model="formData.delay_unit_alert"
                      label-class="form-label"
                      :parent-id="'#'+id"
                  >
                        <option v-for="delay in delayFrequencyEnum" :key="delay.value" :value="delay.value"> {{ delay[locale] }} </option>
                    </Select2>
                </span>
          </Input>
          <div class="col-6 d-flex align-items-center">
            <label :for="`input-${id}-task-critical-delay-value`">
              {{ $t('reminder.inLate') }}
            </label>
          </div>
          <Input
              :name="`${id}-task-alert-delay-value`"
              container-class="col-6 mb-5"
              type="number"
              :isRequired="true"
              size="lg"
              v-model="formData.delay_value_critical"
              :IsInputGroup="true"
          >
                <span class="input-group-text w-50 border-0 py-0">
                  <Select2
                      container-class="w-100 p-0"
                      select-class="form-select form-select-transparent w-100 fs-7 lh-1 fw-bold py-0 select2-hidden-accessible"
                      :isRequired="false"
                      :multiple="false"
                      :show-search="true"
                      :name="`${id}-task-critical-delay-unit`"
                      v-model="formData.delay_unit_critical"
                      label-class="form-label"
                      :parent-id="'#'+id"
                  >
                        <option v-for="delay in delayFrequencyEnum" :key="delay.value" :value="delay.value"> {{ delay[locale] }} </option>
                    </Select2>
                </span>
          </Input>
        </div>
        <Card class="card p-5 mb-5">
            <SwitchInput id="withDetails" :label="$t('tasks.label.details')" v-model="withDetails" :between="true"/>
        </Card>
        <div class="row" v-if="withDetails">
                <CKEditor 
                    :label="$t('tasks.label.description')"
                    id="invoice-editor"
                    :content="formData.description"
                    @text="getNote"
                />
        </div>
        
    </div>

 </template>
 
<script setup>
import { parse, format } from 'date-fns'
import {defineProps, onMounted, ref} from 'vue';
import Select2 from '@/components/Select2.vue';
import Input from '@/components/Input.vue';
import CKEditor from '@/components/CKEditor.vue';
import SwitchInput from '@/components/SwitchInput.vue';
import Card from '@/components/Card.vue';
import { computed } from 'vue';
import {useLocales} from "@/composables/locales";
import {useStore} from "vuex";
import {useProjectEnums} from "@/Modules/Projects/composables/projectEnums";
import InputDate2 from "@/components/InputDate.vue";

const store = useStore()
const { locale } = useLocales()
const { taskDelayEnums } = useProjectEnums()

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
    modelValue: Object,
    id:{type: String, default:"create_modal"},
    contacts: {type: Array, default: []},
    users: {type: Array, default: []},
    milestones: {type: Array, default: []},
    priorities: {type: Array, default: []},
    min: {type: Date, required: false},
    max: {type: Date, required: false}
})

const withDetails = ref(false)
const withReminder = ref(false)
const delayFrequencyEnum = computed(() => store.getters["configs/getFrequencyEnum"])
const formData = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value)
});

const status = computed(() => {
    if(formData.value.project_category_step_id){
        let selected = props.milestones?.filter(el => el?.id == formData.value.project_category_step_id)
        if(selected?.length > 0){
            return selected[0]?.status
        }
    }
    return []
})

function getNote(text) {
    formData.value.description = text
}

function openCreatePriority () {
    $('#'+props.id).modal('toggle')
    $('#create-priority-modal').modal('toggle')
}

function updateEndDate() {
  if (!formData.value.delay_unit) {
   formData.value.delay_unit = taskDelayEnums.value.DAY.value;
  }

  if (!formData.value.start_date || !formData.value.delay_value) {
   return;
  }

  const startDate = parse(formData.value.start_date, 'dd-MM-yyyy HH:mm', new Date());

  if (isNaN(startDate.getTime())) {
    console.warn("Format de date invalide :", formData.value.start_date);
    return;
  }

  const delayUnit = formData.value.delay_unit;
  let delayMilliseconds = 0;

  switch (delayUnit) {
   case taskDelayEnums.value.MINUTE.value:
     delayMilliseconds = formData.value.delay_value * taskDelayEnums.value.MINUTE.formula;
     break;
   case taskDelayEnums.value.HOUR.value:
     delayMilliseconds = formData.value.delay_value * taskDelayEnums.value.HOUR.formula;
     break;
   case taskDelayEnums.value.DAY.value:
     delayMilliseconds = formData.value.delay_value * taskDelayEnums.value.DAY.formula;
     break;
   case taskDelayEnums.value.WEEK.value:
     delayMilliseconds = formData.value.delay_value * taskDelayEnums.value.WEEK.formula;
     break;
   case taskDelayEnums.value.MONTH.value:
     delayMilliseconds = formData.value.delay_value * taskDelayEnums.value.MONTH.formula;
     break;
   case taskDelayEnums.value.YEAR.value:
     delayMilliseconds = formData.value.delay_value * taskDelayEnums.value.YEAR.formula;
     break;
   default:
     console.warn("Unité de délai non reconnue :", delayUnit);
     return;
  }

  const endDate = new Date(startDate.getTime() + delayMilliseconds);
  formData.value.end_date = format(endDate, 'dd-MM-yyyy HH:mm')
}

function resetDelay() {
  formData.value.delay_value = 0
}

function handleStartDateChange() {
  if(formData.value.delay_value && formData.value.delay_unit) {
    updateEndDate()
  }
}

function toggleAlertModal() {
  $('#'+props.id).modal('toggle')
  $('#alert-config-modal').modal('toggle')
}

onMounted(() => {
  store.dispatch('configs/loadFrequencyEnum')
})




</script>

<style>

</style>